module.exports = __webpack_public_path__ + "static/media/banner.05ac9311.styl";